<template>
  <listing-layout>
    <h1 slot="heading" class="h2">Titles</h1>
    <div slot="content">
      <div class="alert alert-success" v-if="success">{{success}}</div>
      
      <data-table :dataRows="rows" :dataColumns="columns" :options="options">
        <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.name" :link="'Edit Title'" :row="row" :edit="true" :options="{ showLinks: true, expandMobile: true, showStatus: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li class="pt-2">
              <tableButtonTemplate :text="'Edit Title'" :link="'Edit Title'" :row="row" :edit="true" />
            </li>
          </ul>
        </div>
      </data-table>
    </div>
  </listing-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
* to their respective fields in the ListingLayout component. */

import axios from 'axios'
import listingLayout from '@/components/ListingLayout'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'
import tableButtonTemplate from '@/components/DataTableFields/Button'

export default {
  name: 'TitlesList',
  props: ['success'],
  components: {
    'listing-layout': listingLayout,
    'data-table': dataTable,
    tableTextTemplate,
    tableButtonTemplate
  },
  data() {
    return {
      status: '',
      error: '',
      rows: [],
      columns: [
        {
          label: 'Title',
          headerClass: 'd-none d-lg-table-cell',
          sortable: true,
          filterable: true,
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.name" :link="'Edit Title'" :row="row" :edit="true" :options="{ showLinks: true, showStatus: true }" />`
          }),
          representedAs(row) { return `${row.name}` }
        },
        {
          label: 'Edit',
          field: '',
          align: 'left',
          sortable: false,
          filterable: false,
          headerClass: 'd-none d-lg-table-cell column-lg-medium',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableButtonTemplate },
            template: `<tableButtonTemplate :text="'Edit'" :link="'Edit Title'" :row="row" :edit="true" />`
          })
        }
      ],
      options: {
        loaded: false
      }
    }
  },
  mounted() {
    axios.get(`${this.$api}/title-list`).then((response) => {
      // eslint-disable-next-line
      // console.log(response)
      if (response.data.status === 'success') {
        this.error = ''
        this.rows = response.data.data
        this.options.loaded = true
      } else {
        this.error = 'Unable to receive data from the server. Please reload the page.'
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Titles/Listing/Titles.vue